import { HashRouter, Routes, Route } from 'react-router-dom';
import React from 'react';

import { PageBody } from './components/PageBody/PageBody';
import { MastermindApp } from './MastermindStuff/MastermindApp';

import { GravityProject } from './ProjectPages/Gravity';
import { PortfolioProject } from './ProjectPages/Website';
import { Projects } from './components/Projects/Projects';
import { Resume } from './components/Resume/Resume';
import { Home } from './components/Home/Home';

interface AppProps{
  pageOn: string,
}

export class App extends React.Component<{}, AppProps>{
  constructor(props: {}){
    super(props);
    this.state =  {pageOn: ''};
  }

  setPageOn(pageOn: string): void{
    this.setState({pageOn: pageOn});
  }

  render(): React.ReactNode{
    return (
      <HashRouter>
        <Routes>
          <Route path = "/" element={ <PageBody/> }>
            <Route path="/" element={<Home />} />
            <Route path="/Projects" element={<Projects />} />
            <Route path="/Resume" element={<Resume />} /> 
            <Route path="/Portfolio" element={<PortfolioProject />} />
            <Route path="/Gravity" element={<GravityProject />} /> 
          </Route>
          <Route path = "/CodeCrackr" element={ <MastermindApp/> }/>
        </Routes>
      </HashRouter>
    )
  }
};

const PageNum = (name: string): number => {
  switch(name){
    case "Home":
      return 0;
    case "Projects":
      return 1;
    case "Resume":
      return 2;
    default:
      return 3;
  }
}
